// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2utQU","icon":"SortAdornment_icon__1i0gD","up":"SortAdornment_up__3mx3i","down":"SortAdornment_down__1ijAA","active":"SortAdornment_active__39yFt"};